<template>
  <div class="footer-wrapper">
    <div class="top">
      <div class="left">
        <i class="line"></i>
        <span>关注我们</span>
        <div class="weibo-box" @mouseover="showQrcode(1)" @mouseleave="hideQrcode(1)">
          <i class="icon-weixin"></i>
          <img :src="qrcode[1]" class="qrcode" v-show="showCode[1]" />
        </div>
        <div class="weibo-box" @mouseover="showQrcode(2)" @mouseleave="hideQrcode(2)">
          <i class="icon-gwxiaochengxu"></i>
          <img :src="qrcode[2]" class="qrcode" v-show="showCode[2]" />
        </div>
        <div class="weibo-box" @mouseover="showQrcode(3)" @mouseleave="hideQrcode(3)">
          <i class="icon-gwdouyin"></i>
          <img :src="qrcode[3]" class="qrcode" v-show="showCode[3]" />
        </div>
        <div class="weibo-box" @mouseover="showQrcode(4)" @mouseleave="hideQrcode(4)">
          <img :src="require('@/assets/images/lrb_icon@2x.png')" />
          <img :src="qrcode[4]" class="qrcode" v-show="showCode[4]" />
        </div>
        <div class="weibo-box">
          <i class="icon-gwxinlangweibo" @click="toBlog"></i>
        </div>
      </div>

      <div class="center">
        <img class="logImg" :src="require('@/assets/images/Type_Badge_Properties_White.png')" />
      </div>

      <div class="right">
        <span class="tel" @click="toProductDetail"><a style="color:#fff">信息披露</a></span>
        <span class="tel" @click="toUseTerms"><a style="color:#fff">使用条款</a></span>
        <span>联系我们</span>
        <span>95105848</span>
      </div>
    </div>
    <div class="bom">
      <div>版权归特百惠（中国）有限公司所有，未经许可不得转载或链接</div>
      <div><a href="https://beian.miit.gov.cn/" target="_blank" style="color:#999">粤ICP备09130465号</a></div>
    </div>
  </div>
</template>
<script>
import { buryPoint } from '@/util/utils'
export default {
  data() {
    return {
      qrcode: {
        1: require('@/assets/images/公众号@2x.png'),
        2: require('@/assets/images/小程序@2x.png'),
        3: require('@/assets/images/抖音@2x.png'),
        4: require('@/assets/images/小红书@2x.png'),
      },
      showCode: {
        1: false,
        2: false,
        3: false,
        4: false,
      }
    }
  },
  methods: {
    toProductDetail() {
      buryPoint('Button_Click', { button_name: '信息披露' })
      this.$router.push({
        path: `/infoDisclosure`
      })
    },
    toUseTerms() {
      buryPoint('Button_Click', { button_name: '使用条款' })
      this.$router.push({
        path: `/useTerms`
      })
    },
    showQrcode(index) {
      this.showCode[index] = true
    },
    hideQrcode(index) {
      this.showCode[index] = false
    },
    toBlog() {
      window.open('https://weibo.com/tupperwareyes')
    }
  },
  created() { }
}
</script>

<style lang="scss" scoped>
.footer-wrapper {
  height: 300px;
  padding: 56px 24px 40px;
  color: #fff;
  font-size: 16px;
  min-width: 1000px;
  // border-top: 1px solid #eeeeee;
  background-color: #000;

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
  }

  .bom {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    display: flex;
    justify-content: flex-end;

    div+div {
      margin-left: 20px;
    }
  }

  .left {
    margin-top: 75px;
    display: flex;
    height: 40px;
    align-items: center;

    span {
      margin-right: 14px;
    }

    .weibo-box {
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      i {
        font-size: 30px;
      }

      img {
        width: 50%;
      }

      .qrcode {
        position: absolute;
        width: 225px;
        height: 300px;
        left: -82px;
        top: -320px;
        z-index: 1;
      }
    }
  }

  .center {
    .logImg {
      margin-top: -20px;
      width: 140px;
      height: 140px;
    }
  }

  .right {
    margin-top: 75px;
    float: right;
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;
    color: #fff;

    span {
      margin-right: 14px;
    }

    .tel {
      position: relative;
      margin-right: 40px;
      color: #fff;

      &::after {
        content: "";
        position: absolute;
        right: -15px;
        top: -8px;
        width: 1px;
        height: 40px;
        background-color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue